<template>
    <div>
        <v-card :loading="loading" class="pa-3 pt-0">
            <v-card-title>
                Fidelizaciones pendientes
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    @click="dialogFiltroFidelizaciones = true"
                >
                    <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <span>
                    Mostrando 
                    <v-chip
                        
                        class="mr-2"
                        outlined
                        close
                        color="primary"
                        small
                        @click:close="borrarFiltro()"
                    >
                        {{ filtroAplicado }}
                    </v-chip>
                </span>
            </v-card-text>
            <v-text-field
                v-model="buscarFidelizaciones"
                append-icon="mdi-file-search-outline"
                label="Buscar"
                single-line
                hide-details
                class="mb-2"
            ></v-text-field>
            <v-data-table 
                :headers="headersFidelizaciones" 
                :items="fidelizacionesPendientes"
                :search="buscarFidelizaciones"
                sort-by="fechaFidelizacion"
            >
                <template v-slot:item.acciones="{ item }">
                    <v-btn icon link :href="`${v3Url}/partes/${item.parte_id}`" >
                        <v-icon>mdi-launch</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.descripcion="{ item }">
                    <v-textarea
                        v-model="item.descripcion"
                        readonly
                        hide-details
                        rows="1"
                        style="width: 12em;"
                    ></v-textarea>
                </template>
                
                <template v-slot:item.solicitada_por.name="{ item }">
                    <v-chip outlined>
                        <v-avatar left :color="item.solicitada_por.color">
                            <span class="white--text">
                                {{ item.solicitada_por.avatar }}
                            </span>
                        </v-avatar>
                        {{ item.solicitada_por.name }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>
        <!-- Dialog filtro fidelizaciones -->
        <v-dialog v-model="dialogFiltroFidelizaciones" persistent max-width="380">
            <v-card>
                <v-card-title class="headline">Filtrar fidelizaciones</v-card-title>
                <v-card-text>
                    <date-picker
                        ref="datePickerFechaFidelizaciones"
                        :date="fechaFidelizaciones"
                        title="Fecha fidelizaciones"
                        v-bind:conIcono="true"
                        @actualizarFecha="actualizarFechaFidelizaciones"
                    ></date-picker>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelar()">Cancelar</v-btn>
                    <v-btn text color="primary" @click="aceptar()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from "vuex";
import Datepicker from "../../components/utils/Datepicker";
import formatearFecha from '../../mixins/formatearFecha';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    mixins: [formatearFecha],
    data: () => ({
        buscarFidelizaciones: '',
        dialogFiltroFidelizaciones: false,
        headersFidelizaciones: [
            {
                text: 'Núm. Parte',
                filterable: false,
                value: 'parte.numParte',
            },
            {
                text: 'Cliente',
                filterable: true,
                sortable: true,
                value: 'parte.cliente',
            },
            {
                text: 'Fecha',
                filterable: true,
                value: 'fechaFidelizacion',
            },
            {
                text: 'Solicitante',
                filterable: true,
                sortable: true,
                value: 'solicitada_por.name',
            },
            {
                text: 'Tipo',
                filterable: true,
                sortable: true,
                value: 'tipo_fidelizacion.nombre',
            },
            {
                text: 'Descripción',
                filterable: true,
                sortable: false,
                value: 'descripcion',
            },
            {
                text: 'Acciones',
                filterable: false,
                align: 'center',
                sortable: false,
                value: 'acciones'
            }
        ],
        fidelizacionesPendientes: [],
        loading: false,
        fechaFidelizaciones: new Date().toLocaleDateString("en-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }),
        fechaFidelizacionesDialog: null,
        v3Url: process.env.VUE_APP_V3_URL
    }),
    mounted(){
        //OBTENER FIDELIZACIONES ASIGNADAS AL USUARIO LOGEADO
        this.loading = true;
        let params = {
            fechaFidelizaciones: this.fechaFidelizaciones
        }
        axios.get("/api/fidelizaciones", { params }).then((respueta) => {
            this.fidelizacionesPendientes = respueta.data;
        }).catch((error) => {
            // console.log(error);
            this.setSnackbar({
                tipo: "error",
                mensaje: "Error. No se han podido recuperar las fidelizaciones",
            });
        }).finally(() => {
          this.loading = false;
        });
    },
    methods: {
        ...mapActions(['setSnackbar']),
        actualizarFechaFidelizaciones(val) {
            this.fechaFidelizacionesDialog = val;
        },
        aceptar(){
            this.fechaFidelizaciones = this.fechaFidelizacionesDialog;
            this.dialogFiltroFidelizaciones = false;
            this.filtrar();
        },
        cancelar(){
            this.dialogFiltroFidelizaciones = false;
            this.fechaFidelizacionesDialog = this.fechaFidelizaciones;

        },
        filtrar(){
            this.loading = true;
            let params = {
                fechaFidelizaciones: this.fechaFidelizaciones
            }
            axios.get("/api/fidelizaciones", { params }).then((respueta) => {
                this.fidelizacionesPendientes = respueta.data;
            }).catch((error) => {
                // console.log(error);
                this.setSnackbar({
                    tipo: "error",
                    mensaje: "Error. No se han podido recuperar las fidelizaciones",
                });
            }).finally(() => {
                this.loading = false;
            });
        },
        borrarFiltro(){
            this.fechaFidelizaciones = null;
            this.filtrar();
        }
    },
    computed: {
        filtroAplicado() {
            if(this.fechaFidelizaciones === null){
                return 'Todas';
            }
            return this.formatDate(this.fechaFidelizaciones);
        }
    },
    components: {
        "date-picker": Datepicker,
    },
}
</script>